export default "__VITE_PUBLIC_ASSET__4b651673__"